import React from 'react';
import { Button, Alert } from 'reactstrap';
import axios from 'axios'
import url from '../../url'
import './journey-edit.css';
import Loading from '../loading/Loading';


class JourneyEdit extends React.Component {
    journey = {
        journeyId: this.props.data.journeyId || "",
        driverId: this.props.driver.driverObjectId,
        startTime: "",
        endTime: "",
        adjustments: [],
        justification: this.props.data.justification || '',
        dateBase: ''
    }
    _appends = []

    justifys = [
        { label: 'Folga', value: 'DAY_OFF' },
        { label: 'Férias', value: 'VACATION' },
        { label: 'Atestado', value: 'MEDICAL_CERTIFICATE' }
    ]



    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            deleteJourney: false,
            dateJourney: this.formatDate(this.props.data.dateJourney),
            startJourney: this.props.data.journey.start.show || '',
            endJourney: this.props.data.journey.end.show || '',
            startRest: this.props.data.rest[0] ? this.props.data.rest[0].start.show : '',
            startRest2: this.props.data.rest[1] ? this.props.data.rest[1].start.show : '',
            endRest: this.props.data.rest[0] ? this.props.data.rest[0].end.show : '',
            endRest2: this.props.data.rest[1] ? this.props.data.rest[1].end.show : '',
            startFood: this.props.data.food[0] ? this.props.data.food[0].start.show : '',
            startFood2: this.props.data.food[1] ? this.props.data.food[1].start.show : '',
            endFood: this.props.data.food[0] ? this.props.data.food[0].end.show : '',
            endFood2: this.props.data.food[1] ? this.props.data.food[1].end.show : '',
            startWait: this.props.data.wait[0] ? this.props.data.wait[0].start.show : '',
            startWait2: this.props.data.wait[1] ? this.props.data.wait[1].start.show : '',
            endWait: this.props.data.wait[0] ? this.props.data.wait[0].end.show : '',
            endWait2: this.props.data.wait[1] ? this.props.data.wait[1].end.show : '',
            appends: {
                rest: !this.props.data.rest[1] ? false : true,
                food: !this.props.data.food[1] ? false : true,
                wait: !this.props.data.wait[1] ? false : true,
            }
        }
    }

    clear = () => {
        this.setState({
            startJourney: '00:00',
            endJourney: '00:00',
            startRest: '00:00',
            startRest2: '',
            endRest: '00:00',
            endRest2: '',
            startFood: '00:00',
            startFood2: '',
            endFood: '00:00',
            endFood2: '',
            startWait: '00:00',
            startWait2: '',
            endWait: '00:00',
            endWait2: '',
            appends: {
                rest: false,
                food: false,
                wait: false,
            }

        })
    }

    formatDate = date => {
        var a = date.split(", ")
        return a[1]
    }

    changeInput = (type, val) => {
        switch (type) {

            case 'JOURNEY-start':
                this.journey.startTime = `${this.state.dateJourney} ${val}`
                this.setState({ startJourney: val })
                break;

            case 'JOURNEY-end':
                this.journey.endTime = `${this.state.dateJourney} ${val}`
                this.setState({ endJourney: val })
                break;

            case 'REST-start':
                this.addAdjustments({
                    eventId: this.props.data.rest[0] ? this.props.data.rest[0].eventId : '',
                    eventType: 'REST',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endRest}`

                })
                this.setState({ startRest: val })
                break;

            case 'REST-end':
                this.addAdjustments({
                    eventId: this.props.data.rest[0] ? this.props.data.rest[0].eventId : '',
                    eventType: 'REST',
                    startTime: `${this.state.dateJourney} ${this.state.startRest}`,
                    endTime: `${this.state.dateJourney} ${val}`

                })
                this.setState({ endRest: val })
                break;

            case 'FOOD-start':
                this.addAdjustments({
                    eventId: this.props.data.food[0] ? this.props.data.food[0].eventId : '',
                    eventType: 'FOOD',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endFood}`

                })
                this.setState({ startFood: val })
                break;

            case 'FOOD-end':
                this.addAdjustments({
                    eventId: this.props.data.food[0] ? this.props.data.food[0].eventId : '',
                    eventType: 'FOOD',
                    startTime: `${this.state.dateJourney} ${this.state.startFood}`,
                    endTime: `${this.state.dateJourney} ${val}`

                })
                this.setState({ endFood: val })
                break;

            case 'WAIT-start':
                this.addAdjustments({
                    eventId: this.props.data.wait[0] ? this.props.data.wait[0].eventId : '',
                    eventType: 'WAIT',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endWait}`

                })
                this.setState({ startWait: val })
                break;

            case 'WAIT-end':
                this.addAdjustments({
                    eventId: this.props.data.wait[0] ? this.props.data.wait[0].eventId : '',
                    eventType: 'WAIT',
                    startTime: `${this.state.dateJourney} ${this.state.startWait}`,
                    endTime: `${this.state.dateJourney} ${val}`

                })
                this.setState({ endWait: val })
                break;



            default:
                break;
        }
    }

    changeInputsAppend = (type, val) => {
        switch (type) {
            case 'REST-start':
                this.addAdjustments({
                    eventId: this.props.data.rest[1] ? this.props.data.rest[1].eventId : '',
                    eventType: 'REST',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endRest2}`

                }, true)
                this.setState({ startRest2: val })
                break;

            case 'REST-end':
                this.addAdjustments({
                    eventId: this.props.data.rest[1] ? this.props.data.rest[1].eventId : '',
                    eventType: 'REST',
                    startTime: `${this.state.dateJourney} ${this.state.startRest2}`,
                    endTime: `${this.state.dateJourney} ${val}`

                }, true)
                this.setState({ endRest2: val })
                break;

            case 'FOOD-start':
                this.addAdjustments({
                    eventId: this.props.data.food[1] ? this.props.data.food[1].eventId : '',
                    eventType: 'FOOD',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endFood2}`

                }, true)
                this.setState({ startFood2: val })
                break;

            case 'FOOD-end':
                this.addAdjustments({
                    eventId: this.props.data.food[1] ? this.props.data.food[1].eventId : '',
                    eventType: 'FOOD',
                    startTime: `${this.state.dateJourney} ${this.state.startFood2}`,
                    endTime: `${this.state.dateJourney} ${val}`

                }, true)
                this.setState({ endFood2: val })
                break;

            case 'WAIT-start':
                this.addAdjustments({
                    eventId: this.props.data.wait[1] ? this.props.data.wait[1].eventId : '',
                    eventType: 'WAIT',
                    startTime: `${this.state.dateJourney} ${val}`,
                    endTime: `${this.state.dateJourney} ${this.state.endWait2}`

                }, true)
                this.setState({ startWait2: val })
                break;

            case 'WAIT-end':
                this.addAdjustments({
                    eventId: this.props.data.wait[1] ? this.props.data.wait[1].eventId : '',
                    eventType: 'WAIT',
                    startTime: `${this.state.dateJourney} ${this.state.startWait2}`,
                    endTime: `${this.state.dateJourney} ${val}`

                }, true)
                this.setState({ endWait2: val })
                break;



            default:
                break;
        }
    }

    addAdjustments = (adj, append) => {
        let have = false
        let ind = 0

        if (append) {
            this._appends.forEach((d, i) => {
                if (adj.eventType === d.eventType) {
                    have = true
                    ind = i
                }
            })
            if (have) {
                this._appends[ind] = adj
            } else {
                this._appends.push(adj)
            }
        } else {
            this.journey.adjustments.forEach((d, i) => {
                if (adj.eventType === d.eventType) {
                    have = true
                    ind = i
                }
            })

            if (have) {
                this.journey.adjustments[ind] = adj
            } else {
                this.journey.adjustments.push(adj)
            }
        }
    }

    appends = (append, action) => {
        var appends = this.state.appends;
        var iRemove = -1
        if (!action) {
            this._appends.forEach((d, i) => {
                if (d.eventType === append) {
                    iRemove = i
                }
            })
            if (iRemove => 0) {
                this._appends.splice(iRemove, 1)
            }


        }

        switch (append) {
            case 'REST':
                appends.rest = action
                if (!action) {
                    this.addAdjustments({
                        eventId: this.props.data.rest[1] ? this.props.data.rest[1].eventId : '',
                        eventType: 'REST',
                        startTime: ``,
                        endTime: ``

                    }, true)
                    this.setState({ startRest2: '', endRest2: '' })
                }
                break;

            case 'FOOD':
                appends.food = action
                if (!action) {
                    this.addAdjustments({
                        eventId: this.props.data.food[1] ? this.props.data.food[1].eventId : '',
                        eventType: 'FOOD',
                        startTime: ``,
                        endTime: ``

                    }, true)
                    this.setState({ startFood2: '', endFood2: '' })
                }
                break;

            case 'WAIT':
                appends.wait = action
                if (!action) {
                    this.addAdjustments({
                        eventId: this.props.data.wait[1] ? this.props.data.wait[1].eventId : '',
                        eventType: 'WAIT',
                        startTime: ``,
                        endTime: ``

                    }, true)
                    this.setState({ startWait2: '', endWait2: '' })
                }
                break;

            default:
                break;
        }

        this.setState({ appends })



    }

    save = () => {
        this.setState({ alertMsg: null, loading: true })
        this.journey.adjustments = this.journey.adjustments.concat(this._appends)
        this.journey.dateBase = this.formatDate(this.props.data.dateJourney)
        console.log(this.journey)
        axios({
            method: !this.journey.journeyId ? 'put' : 'post',
            url: `${url}/v1/telemetria/admin/journey/adjustment/${this.props.token}`,
            data: this.journey
        }).then(d => {
            console.log(d)
            this.props._function(this.props.data.dateJourney)
        }).catch(e => {
            console.log(e.response)
            this.setState({ alertMsg: e.response.data.errorMessage, loading: false })
        })
    }

    changeJustify = val => {
        if (val === this.journey.justification) {
            this.journey.justification = ''
        } else {
            this.journey.justification = val
        }

        this.setState({})

    }

    deleteJourney = () => {
        console.log(this.journey.journeyId)
        axios.delete(
          `${url}/v1/telemetria/admin/journey/delete/${this.journey.journeyId}/${this.props.token}`)
          .then(d => {
            console.log(d)
            this.props._function(this.props.data.dateJourney, 'delete')
          }).catch(e => {
            console.log(e.response)
            this.setState({ alertMsg: e.response.data.errorMessage, loading: false })
        })
    }

    render() {
        return (
            <div className='ballon-add-journey'>

                <div className='ballon-add-journey-line'>
                    <p className='title-line-add-journey' >Inicio da Jornada</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('JOURNEY-start', i.target.value)} value={this.state.startJourney} />
                    <i className="fas fa-eraser append-icon trash-add-journey" onClick={() => this.clear()} style={{ fontSize: '14px' }}></i>
                    {this.journey.journeyId ? (<i className="fas fa-trash append-icon trash-add-journey" onClick={() => this.setState({deleteJourney: true})} style={{ marginLeft: this.journey.journeyId ? '10px' : null }}></i>) : null}
                </div>
                <hr />
                {this.state.deleteJourney ? ( <div><div className='ballon-add-journey-line' style={{paddingBottom: '10px'}}>
                    <p className='title-line-add-journey' >Excluir a Jornada ?</p>
                    <Button
                        color="primary"
                        className="button-add-journey"
                        onClick={() => this.deleteJourney()}
                        style={{marginBotton: '20px'}}

                    >
                        Sim
                    </Button>
                    <Button
                        color="primary"
                        className="button-add-journey"
                        onClick={() => this.setState({deleteJourney: false})}
                        style={{marginBotton: '20px'}}
                    >
                        Não
                    </Button>
                </div>
                <hr />
                </div>) : null}
               




                <div className='ballon-add-journey-line'>
                    <p className='title-line-add-journey' >Tempo de Descanso</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('REST-start', i.target.value)} value={this.state.startRest} />
                    <p className='pipe-line-add-journey'>|</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('REST-end', i.target.value)} value={this.state.endRest} />
                    <i className={`fas fa-plus append-icon ${this.state.appends.rest ? 'd-none' : ''}`} onClick={() => this.appends('REST', true)}></i>
                </div>
                {this.state.appends.rest ? (
                    <div className='ballon-add-journey-line'>
                        <p className='title-line-add-journey' >2° Tempo de Descanso</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('REST-start', i.target.value)} value={this.state.startRest2} />
                        <p className='pipe-line-add-journey'>|</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('REST-end', i.target.value)} value={this.state.endRest2} />
                        <i className={`fas fa-minus append-icon`} onClick={() => this.appends('REST', false)}></i>
                    </div>
                ) : null}
                <hr />

                <div className='ballon-add-journey-line'>
                    <p className='title-line-add-journey' >Intervalo de Refeição</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('FOOD-start', i.target.value)} value={this.state.startFood} />
                    <p className='pipe-line-add-journey'>|</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('FOOD-end', i.target.value)} value={this.state.endFood} />
                    <i className={`fas fa-plus append-icon ${this.state.appends.food ? 'd-none' : ''}`} onClick={() => this.appends('FOOD', true)}></i>
                </div>
                {this.state.appends.food ? (
                    <div className='ballon-add-journey-line'>
                        <p className='title-line-add-journey' >2° Intervalo de Refeição</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('FOOD-start', i.target.value)} value={this.state.startFood2} />
                        <p className='pipe-line-add-journey'>|</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('FOOD-end', i.target.value)} value={this.state.endFood2} />
                        <i className={`fas fa-minus append-icon`} onClick={() => this.appends('FOOD', false)}></i>
                    </div>
                ) : null}
                <hr />

                <div className='ballon-add-journey-line'>
                    <p className='title-line-add-journey' >Tempo de Espera</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('WAIT-start', i.target.value)} value={this.state.startWait} />
                    <p className='pipe-line-add-journey'>|</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('WAIT-end', i.target.value)} value={this.state.endWait} />
                    <i className={`fas fa-plus append-icon ${this.state.appends.wait ? 'd-none' : ''}`} onClick={() => this.appends('WAIT', true)}></i>
                </div>
                {this.state.appends.wait ? (
                    <div className='ballon-add-journey-line'>
                        <p className='title-line-add-journey' >2° Tempo de Espera</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('WAIT-start', i.target.value)} value={this.state.startWait2} />
                        <p className='pipe-line-add-journey'>|</p>
                        <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInputsAppend('WAIT-end', i.target.value)} value={this.state.endWait2} />
                        <i className={`fas fa-minus append-icon`} onClick={() => this.appends('WAIT', false)}></i>
                    </div>
                ) : null}
                <hr />

                <div className='ballon-add-journey-line'>
                    <p className='title-line-add-journey' >Fim da Jornada</p>
                    <input disabled={this.state.loading} type='time' className='input-time-add-journey' min="00:00" max="23:59" onChange={(i) => this.changeInput('JOURNEY-end', i.target.value)} value={this.state.endJourney} />
                </div>
                <hr />

                <div className='ballon-add-journey-line'>
                    <div className='flags-add-journey'>
                        {this.justifys.map((d, i) => {
                            return (
                                <div key={i}>
                                    <input disabled={this.state.loading} type="checkbox" id={d.value} name="flag" value={d.value} onChange={() => this.changeJustify(d.value)} checked={this.journey.justification === d.value} />
                                    <label htmlFor={d.value} className='title-line-add-journey'>{d.label}</label>
                                </div>
                            )
                        })}
                    </div>
                    {this.state.loading ? (
                        <div className='spinner-add-journey'>
                            <Loading size='small'/>
                        </div>
                    ) : (
                            <Button
                                color="primary"
                                className="button-add-journey telemetry-button"
                                onClick={() => this.save()}
                            >
                                Salvar
                            </Button>
                        )}

                </div>
                {this.state.alertMsg ? (
                    <div className='ballon-add-journey-line'>
                        <Alert color='danger' className='alert-add-journey'>
                            {this.state.alertMsg.map((d, i) => {
                                return <p key={i}>{d}</p>
                            })}
                        </Alert>
                    </div>
                ) : null}

            </div>
        )
    }
}

export default JourneyEdit